// extracted by mini-css-extract-plugin
export default {"formAdd":"styles_formAdd__nOdqw","formItem":"styles_formItem__UxfGr","formFull":"styles_formFull__BHQRn","InputNumber":"styles_InputNumber__JEfEW"};